import { Button } from 'antd';
import { useState } from 'react';
import {
  DownloadPersonalizationSummaryPdfModal,
  DownloadPersonalizationSummaryPdfModalProps,
} from './DownloadPersonalizationSummaryPdfModal';

interface Props
  extends Pick<
    DownloadPersonalizationSummaryPdfModalProps,
    | 'downloadButtonIcon'
    | 'downloadButtonTitle'
    | 'initialValue'
    | 'layout'
    | 'onDownload'
    | 'title'
    | 'filterBy'
  > {
  openButtonTitle: string;
  openButtonIcon?: React.ReactNode;
}

export function DownloadPersonalizationSummaryPdfButton({
  openButtonTitle,
  openButtonIcon,
  onDownload,
  ...modalProps
}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button icon={openButtonIcon} onClick={() => setOpen(true)}>
        {openButtonTitle}
      </Button>

      <DownloadPersonalizationSummaryPdfModal
        open={open}
        {...modalProps}
        onClose={() => setOpen(false)}
        onDownload={(values) => {
          onDownload(values, () => setOpen(false));
        }}
      />
    </>
  );
}
